/* CurrentShop — SmartStop — custom scripts (vanilla, no libraries) */
(function () {
  'use strict';

  if (window.__mtScriptsInit) return;
  window.__mtScriptsInit = true;

  function initReveals() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mt-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );
    els.forEach(function (el) { obs.observe(el); });
  }

  function initCountUp() {
    var els = document.querySelectorAll('.mt-countup');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          obs.unobserve(el);
          var target = parseFloat(el.dataset.target || '0');
          var decimals = (el.dataset.target || '').includes('.') ? 1 : 0;
          var duration = 1400;
          var start = null;
          function step(ts) {
            if (start === null) start = ts;
            var progress = Math.min((ts - start) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            el.textContent = (target * eased).toFixed(decimals);
            if (progress < 1) requestAnimationFrame(step);
            else el.textContent = target.toFixed(decimals);
          }
          requestAnimationFrame(step);
        });
      },
      { threshold: 0.4 }
    );
    els.forEach(function (el) { obs.observe(el); });
  }

  function initColorSwitch() {
    var widgets = document.querySelectorAll('[data-mt-colores]');
    widgets.forEach(function (widget) {
      var swatches = widget.querySelectorAll('[data-mt-color-swatch]');
      var img = widget.querySelector('[data-mt-color-imagen]');
      var nombre = widget.querySelector('[data-mt-color-nombre]');
      var cta = widget.querySelector('[data-mt-color-cta]');
      swatches.forEach(function (sw) {
        sw.addEventListener('click', function () {
          swatches.forEach(function (s) { s.classList.remove('mt-activo'); });
          sw.classList.add('mt-activo');
          var src = sw.getAttribute('data-mt-color-imagen');
          var label = sw.getAttribute('data-mt-color-nombre');
          var link = sw.getAttribute('data-mt-color-link');
          if (img && src) {
            img.style.opacity = '0';
            setTimeout(function () {
              img.setAttribute('src', src);
              img.style.opacity = '1';
            }, 180);
          }
          if (nombre && label) nombre.textContent = label;
          if (cta && link) cta.setAttribute('href', link);
        });
      });
    });
  }

  function initTilt() {
    var cards = document.querySelectorAll('[data-mt-tilt]');
    if (!cards.length || window.matchMedia('(pointer: coarse)').matches) return;
    cards.forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'perspective(700px) rotateY(' + (x * 6) + 'deg) rotateX(' + (y * -6) + 'deg) translateY(-4px)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
      });
    });
  }

  function initParallax() {
    var els = document.querySelectorAll('.mt-parallax');
    if (!els.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        var center = r.top + r.height / 2 - vh / 2;
        var move = Math.max(Math.min(center * -0.06, 40), -40);
        el.style.transform = 'translate3d(0,' + move + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function initGaleria() {
    var wraps = document.querySelectorAll('[data-mt-galeria]');
    wraps.forEach(function (wrap) {
      var main = wrap.querySelector('[data-mt-galeria-principal]');
      var thumbs = wrap.querySelectorAll('[data-mt-galeria-thumb]');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          thumbs.forEach(function (t) { t.style.borderColor = 'var(--mt-color-borde)'; });
          thumb.style.borderColor = 'var(--mt-color-acento-2)';
          var src = thumb.getAttribute('data-mt-galeria-src');
          if (main && src) {
            main.style.opacity = '0';
            setTimeout(function () {
              main.setAttribute('src', src);
              main.style.opacity = '1';
            }, 150);
          }
        });
      });
    });
  }

  function initProductoForm() {
    var forms = document.querySelectorAll('[data-mt-producto-form]');
    forms.forEach(function (form) {
      var wrap = form.closest('.mt-producto') || document;
      var script = wrap.querySelector('[data-mt-variantes]');
      if (!script) return;
      var variantes;
      try { variantes = JSON.parse(script.textContent); } catch (e) { return; }
      var selectors = form.querySelectorAll('[data-mt-option-selector]');
      var idInput = form.querySelector('[data-mt-variant-id]');
      var precioEl = wrap.querySelector('[data-mt-precio]');
      var precioCompararEl = wrap.querySelector('[data-mt-precio-comparar]');
      var addBtn = wrap.querySelector('[data-mt-add-btn]');
      var addTexto = wrap.querySelector('[data-mt-add-texto]');
      var textoOriginal = addTexto ? addTexto.textContent : '';

      function formatoDinero(cents) {
        return (cents / 100).toLocaleString(document.documentElement.lang || 'it-IT', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
      }

      function actualizar() {
        if (!selectors.length) return;
        var seleccion = Array.prototype.map.call(selectors, function (s) { return s.value; });
        var match = variantes.filter(function (v) {
          return v.options.every(function (opt, i) { return opt === seleccion[i]; });
        })[0];
        if (!match) return;
        if (idInput) idInput.value = match.id;
        if (precioEl) precioEl.textContent = formatoDinero(match.price);
        if (precioCompararEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            precioCompararEl.textContent = formatoDinero(match.compare_at_price);
            precioCompararEl.style.display = '';
          } else {
            precioCompararEl.style.display = 'none';
          }
        }
        if (addBtn) {
          addBtn.disabled = !match.available;
          if (addTexto) addTexto.textContent = match.available ? textoOriginal : (addBtn.getAttribute('data-mt-agotado-texto') || textoOriginal);
        }
      }

      selectors.forEach(function (sel) { sel.addEventListener('change', actualizar); });
    });
  }

  function initPillSwatches() {
    var groups = document.querySelectorAll('[data-mt-pill-group]');
    groups.forEach(function (group) {
      var idx = group.getAttribute('data-mt-option-index');
      var form = group.closest('form');
      if (!form) return;
      var select = form.querySelector('[data-mt-option-selector][data-mt-option-index="' + idx + '"]');
      if (!select) return;
      var buttons = group.querySelectorAll('[data-mt-pill-value]');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          buttons.forEach(function (b) { b.classList.remove('mt-activo'); });
          btn.classList.add('mt-activo');
          select.value = btn.getAttribute('data-mt-pill-value');
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  function initProductoAddToCart() {
    var forms = document.querySelectorAll('[data-mt-producto-form]');
    forms.forEach(function (form) {
      var enviando = false;
      form.addEventListener('submit', function (evt) {
        evt.preventDefault();
        if (enviando) return;
        enviando = true;

        var wrap = form.closest('.mt-producto') || document;
        var addBtn = wrap.querySelector('[data-mt-add-btn]');
        var addTexto = wrap.querySelector('[data-mt-add-texto]');
        var textoOriginal = addTexto ? addTexto.textContent : '';
        var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

        if (addBtn) addBtn.setAttribute('aria-disabled', 'true');
        if (addTexto) addTexto.textContent = 'Aggiunta in corso…';

        var formData = new FormData(form);
        if (cart && typeof cart.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            cart.getSectionsToRender().map(function (section) { return section.id; })
          );
          formData.append('sections_url', window.location.pathname);
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(addBtn || document.activeElement);
        }

        fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/javascript'
          },
          body: formData
        })
          .then(function (response) { return response.json(); })
          .then(function (response) {
            if (response.status) {
              console.error(response.description || response.message);
              if (addTexto) addTexto.textContent = 'Impossibile aggiungere, riprova';
              return;
            }
            if (cart && typeof cart.renderContents === 'function') {
              cart.renderContents(response);
            } else {
              window.location = (window.routes && window.routes.cart_url) || '/cart';
            }
          })
          .catch(function (err) {
            console.error(err);
            form.submit();
          })
          .finally(function () {
            enviando = false;
            if (addBtn) addBtn.removeAttribute('aria-disabled');
            if (addTexto && addTexto.textContent === 'Aggiunta in corso…') addTexto.textContent = textoOriginal;
          });
      });
    });
  }

  function initComparador() {
    var wraps = document.querySelectorAll('[data-mt-comparador]');
    wraps.forEach(function (wrap) {
      var overlay = wrap.querySelector('[data-mt-comparador-antes]');
      var overlayImg = wrap.querySelector('[data-mt-comparador-antes-img]');
      var manija = wrap.querySelector('[data-mt-comparador-manija]');
      if (!overlay || !overlayImg || !manija) return;
      var dragging = false;

      function ajustarAnchoImagen() {
        overlayImg.style.width = wrap.getBoundingClientRect().width + 'px';
      }

      function setPos(pct) {
        pct = Math.max(0, Math.min(100, pct));
        overlay.style.width = pct + '%';
        manija.style.left = pct + '%';
      }

      function posDesdeEvento(e) {
        var rect = wrap.getBoundingClientRect();
        var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
        return (x / rect.width) * 100;
      }

      manija.addEventListener('mousedown', function () { dragging = true; });
      manija.addEventListener('touchstart', function () { dragging = true; }, { passive: true });
      window.addEventListener('mouseup', function () { dragging = false; });
      window.addEventListener('touchend', function () { dragging = false; });
      window.addEventListener('mousemove', function (e) {
        if (!dragging) return;
        setPos(posDesdeEvento(e));
      });
      window.addEventListener('touchmove', function (e) {
        if (!dragging) return;
        setPos(posDesdeEvento(e));
      }, { passive: true });
      wrap.addEventListener('click', function (e) {
        if (e.target === manija) return;
        setPos(posDesdeEvento(e));
      });

      ajustarAnchoImagen();
      window.addEventListener('resize', ajustarAnchoImagen);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveals();
    initCountUp();
    initColorSwitch();
    initTilt();
    initParallax();
    initGaleria();
    initProductoForm();
    initPillSwatches();
    initProductoAddToCart();
    initComparador();
  });
})();
